import { createSlice } from "@reduxjs/toolkit";
import authApi from "interceptor/authInterceptor";
import { dispatch } from "store";
import toast from "utils/ToastNotistack";

const initialState = {
  employees: [],
  page: 0,
  pageSize: 10,
  totalRecords: 0,
  totalPages: 0,
  isLoading: false,
};

const unregisteredEmployees = createSlice({
  name: "unregisteredEmployees",
  initialState,
  reducers: {
    getEmployees: (state, action) => {
      const { employees, page, pageSize, totalRecords, totalPages } =
        action.payload;
      state.employees = employees;
      state.page = page;
      state.pageSize = pageSize;
      state.totalRecords = totalRecords;
      state.totalPages = totalPages;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearUnregisteredEmployees: () => initialState,
  },
});

export const { getEmployees, setIsLoading, clearUnregisteredEmployees } =
  unregisteredEmployees.actions;

export default unregisteredEmployees.reducer;

export function fetchUnregisteredEmployees(
  page: number,
  pageSize: number,
  companyId: string,
  employeeName: string,
  businessUnitId?: string
) {
  return async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await authApi.get(
        `/v2/api/users/unregistered?page=${page}&pageSize=${pageSize}&companyId=${companyId}&employeeName=${employeeName}&businessUnitId=${
          businessUnitId ? businessUnitId : ""
        }`
      );
      if (response?.data?.data && Array.isArray(response.data.data)) {
        dispatch(
          getEmployees({
            employees: response.data.data.map((emp: any) => ({
              ...emp,
              selected: false,
            })),
            page: response.data.page || 0,
            pageSize: response.data.pageSize || 10,
            totalRecords: response.data.totalRecords || 0,
            totalPages: response.data.totalPages || 0,
          })
        );
      }
    } finally {
      dispatch(setIsLoading(false));
    }
  };
}

export function loadUnregisteredEmployees(unregisteredEmployees: any) {
  return async () => {
    const response = await authApi.post(
      `/v2/api/users/loadUnregistered`,
      unregisteredEmployees
    );
    if (response?.data?.code === 200) {
      if (response.data.message === "Added Successfully") {
        toast(response.data.message, { variant: "success" });
      } else {
        toast(response.data.message, { variant: "info" });
      }
    }
  };
}

export function inviteUnregistered(payload: any) {
  return async () => {
    try {
      const response = await authApi.post(
        `/v2/api/users/inviteEmployees`,
        payload
      );

      if (response?.data?.code === 200) {
        toast(response.data.message || "Invited successfully", { variant: "success" });
      }
    } catch (error: any) {
      console.error("Invite error:", error);
    }
  };
}

export function sendBulkInvitationReminder(staffIds: Array<string>) {
  return async () => {
    try {
      console.log("staffIds", staffIds);
      const response = await authApi.post(
        `/v2/api/users/invitation/sendBulkInvitationReminder`,
        { staffIds }
      );

      if (response?.data?.code === 200) {
        toast(response.data.message || "Invitation Reminders Sent successfully", { variant: "success" });
      }
    } catch (error: any) {
      console.error("Bulk reminder error:", error);
    }
  };
}

export function deleteUnregisteredUser(employeeId: any) {
  return async () => {
    const response = await authApi.delete(
      `/v2/api/users/unregistered/${employeeId}`
    );
    if (response.data) {
      toast(response.data.message, { variant: "success" });
    }
  };
}
